export const contactsData = {
  title: "Kontakty",
  eventOrganizer: {
    name: "Pořadatel akce",
    subject: "KČT, oblast Moravskoslezská",
    subjectForm: "pobočný spolek",
    registrationDetail: "L 29380 vedená u Městského soudu v Praze",
    registrationNumber: {
      name: "IČO",
      value: "71160477",
    },
    dataBox: {
      name: "Datová schránka",
      value: "5yqiip2",
    },
    address: {
      name: "Adresa",
      street: "Na Mýtě 1556/10",
      partOfCity: "Hrabůvka",
      postCode: "700 30",
      city: "Ostrava",
    },
    email: {
      name: "e-mail",
      value: "kct.msk@email.cz",
    },
    secretariatPhoneNumber: {
      name: "mobil sekretariát",
      value: "+420 736 754 652",
    },
    bankDetails: {
      bankAccount: {
        name: "Bankovní účet",
        value: "131-3414290267/0100",
      },
      IBAN: {
        name: "IBAN",
        value: "CZ53 0100 0001 3134 1429 0267",
      },
      SWIFT: {
        name: "BIC (SWIFT) kod",
        value: "KOMBCZPPXXX",
      },
    },
  },
  organizationalTeam: {
    name: "Organizační tým",
    sections: [
      {
        type: "Hlavní organizátor, turistický program",
        contactPerson: {
          title: "Mgr.",
          firstName: "Ondřej",
          lastName: "Burel",
          email: "ondrasek.bur@seznam.cz",
          phoneNumber: "+420 721 281 992",
        },
      },
      {
        type: "Zajímavosti, historie, rozpočet",
        contactPerson: {
          title: "Ing.",
          firstName: "Břetislav",
          lastName: "Boháč",
          email: "bretislav.bohac@seznam.cz",
          phoneNumber: "+420 602 764 043",
        },
      },
      {
        type: "Registrace účastníků, e-přihlášky",
        contactPerson: {
          title: "",
          firstName: "Petr",
          lastName: "Minka",
          email: "mphav@seznam.cz",
          phoneNumber: "+420 774 218 342",
        },
      },
      {
        type: "Doprovodný program, TOM",
        contactPerson: {
          title: "Ing. Mgr.",
          firstName: "Jan",
          lastName: "Říčný",
          email: "ricnyj@gmail.com",
          phoneNumber: "+420 777 917 481",
        },
      },
      {
        type: "Ubytování, propagace, zahraniční spolupráce",
        contactPerson: {
          title: "Bc.",
          firstName: "Renata",
          lastName: "Kotalová",
          email: "renata.kotalova@seznam.cz",
          phoneNumber: "+420 728 409 175",
        },
      },
      {
        type: "Zimní táboření",
        contactPerson: {
          title: "",
          firstName: "Bohumír",
          lastName: "Boruta",
          email: "BobanekXL@seznam.cz",
          phoneNumber: "+420 778 759 734",
        },
      },
    ],
  },
};
